import { UiTheme } from '@jarvis/react-setup-and-onboarding-addons'
import React, { useMemo, PropsWithChildren } from 'react'
import { ThemeProvider as StyledThemeProvider } from 'styled-components'

import { Container } from './ThemeProvider.styled'

import { useODSessionContext } from '@/hooks/useODSessionContext'
import { ConfigStore } from '@/stores/config'

export const ThemeProvider = ({ children }: PropsWithChildren<object>) => {
  const { ui } = ConfigStore.use

  const { entry } = useODSessionContext()

  const isHpx = useMemo(() => ui === UiTheme.hpx, [ui])

  const isSmallville = useMemo(() => entry === 'earlyOobe', [entry])

  return (
    <StyledThemeProvider theme={{ isHpx, isSmallville }}>
      <Container>{children}</Container>
    </StyledThemeProvider>
  )
}
